import { DELIVERY_TYPES, ORDER_STATUSES, menuState } from "@/utils/guestOrderStatus";

export { LEGACY_UI_VALUE, parseIds, parseRange, serializeIds } from "@/components/report/desktop/reportQuery";

/**
 * Stanje izveštaja gostiju u adresi (hash router: /#/guest-report?r=orders&from=…&to=…&st=pending&dt=0&rs=1,2).
 * Prazna vrednost znači podrazumevano: danas, svi statusi, sve vrste isporuke, svi restorani.
 */
export const GUEST_QUERY = {
  report: "r",
  from: "from",
  to: "to",
  status: "st",
  delivery: "dt",
  restaurants: "rs",
  legacy: "ui",
};

export const MANAGED_GUEST_QUERY = ["r", "from", "to", "st", "dt", "rs"];

/** Status iz adrese ili "" (nepoznat status se ignoriše) */
export const parseStatus = (value) => {
  const state = menuState(value);
  return ORDER_STATUSES.some((status) => status.value === state) ? state : "";
};

/** Vrsta isporuke iz adrese ili null */
export const parseDelivery = (value) => {
  if (value === undefined || value === null || value === "") {
    return null;
  }
  const id = Number(value);
  return DELIVERY_TYPES.some((type) => type.id === id) ? id : null;
};
